import { createNavigation } from 'next-intl/navigation';
import { routing } from './routing';

/**
 * Wrappers de navegación locale-aware. Reemplazan los imports de `next/link`,
 * `next/navigation` y `redirect` en componentes que viven dentro del segmento
 * `[locale]`. Estos componentes/funciones agregan automáticamente el prefix
 * `/en` cuando el locale activo es `en-US`.
 *
 * Uso:
 *   import { Link, useRouter, redirect, usePathname } from '@/lib/i18n/navigation';
 *
 * Para navegar entre locales explícitamente:
 *   <Link href="/colecciones" locale="en-US">English</Link>
 */
export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);
